export const ChannelStatusConstant = {
  ACTIVE: 1,
  DELETE: -1,
  DISABLED: 0,
};

export const ChannelTypeConstant = {
  SHOPIFY: 1,
  WOOCOMMERCE: 2,
  AMAZON: 3,
  API2CART: 4,
  HUBSPOT: 5,
  ECARTAPI: 6,
  TRACKSTAR: 7,
};

export const LuminousInvoicesChannelConstant = 'Luminous Invoices';

export const ChannelIntegrationActionConstant = {
  CREATE_ORDER: 'CREATE_ORDER',
  GET_ORDER: 'GET_ORDER',
  GET_ORDERS: 'GET_ORDERS',
  UPDATE_ORDER: 'UPDATE_ORDER',
  DELETE_ORDER: 'DELETE_ORDER',
};

export const ChannelIntegrationStatusConstant = {
  SUCCESSFUL: 'SUCCESSFUL',
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS',
};
